module.exports = __webpack_public_path__ + "img/Huawei.89c1e4b5.svg";